<template>
  <router-view/>
</template>
<style>
</style>
<script>
require("bootstrap/dist/css/bootstrap.css");
</script>